import { useState } from 'react'

import { updateSetMembership } from './useFileFormFieldsStatus.utils'

export function useFileFormFieldsStatus() {
  const [filesUploadingSet, setFilesUploadingSet] = useState(() => new Set())
  const [filesErrorSet, setFilesErrorSet] = useState(() => new Set())

  function setFileUploading({ enabled, fieldName }) {
    setFilesUploadingSet(prev =>
      updateSetMembership({ enabled, key: fieldName, set: prev })
    )
  }

  function setFileError({ enabled, fieldName }) {
    setFilesErrorSet(prev =>
      updateSetMembership({ enabled, key: fieldName, set: prev })
    )
  }

  const filesUploading = Array.from(filesUploadingSet)
  const filesError = Array.from(filesErrorSet)

  return {
    filesError,
    filesUploading,
    setFileError,
    setFileUploading,
  }
}
